import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Spin } from 'antd';
import { useAuthStore } from './store/authStore';
import MainLayout from './layouts/MainLayout';
import Login from './pages/Login';
import Home from './pages/Home';
import Dashboard from './pages/Dashboard';
import ServerList from './pages/ServerList';
import ServerDetail from './pages/ServerDetail';
import AdminList from './pages/AdminList';
import MqttServerManagement from './pages/MqttServerManagement';
import MqttSubscriptionManagement from './pages/MqttSubscriptionManagement';
import CommandTest from './pages/CommandTest';
import ApiLogList from './pages/ApiLogList';
import Profile from './pages/Profile';
import BuildJobs from './pages/build/BuildJobs';
import BuildManagement from './pages/build/BuildManagement';
import NotFound from './pages/NotFound';

const App: React.FC = () => {
  const { token, role, checkAuth } = useAuthStore();
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    const initAuth = async () => {
      await checkAuth();
      setIsReady(true);
    };

    initAuth();
  }, [checkAuth]);

  if (!isReady) {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          gap: 12,
        }}
      >
        <Spin size="large" />
        <span style={{ color: 'rgba(0,0,0,0.45)' }}>加载中...</span>
      </div>
    );
  }

  return (
    <Router>
      <Routes>
        <Route path="/home" element={<Home />} />
        <Route path="/login" element={token ? <Navigate to="/" /> : <Login />} />
        
        <Route path="/" element={token ? <MainLayout /> : <Navigate to="/home" />}>
          <Route index element={<Dashboard />} />
          <Route path="servers" element={<ServerList />} />
          <Route path="servers/:id" element={<ServerDetail />} />
          {/* RBAC 路由门禁：与后端 @Roles 保持一致 */}
          <Route path="admins" element={role === 'admin' ? <AdminList /> : <Navigate to="/" />} />
          <Route path="mqtt-servers" element={role === 'admin' ? <MqttServerManagement /> : <Navigate to="/" />} />
          <Route path="mqtt-subscriptions" element={role === 'admin' ? <MqttSubscriptionManagement /> : <Navigate to="/" />} />
          <Route path="command-test" element={role === 'viewer' ? <Navigate to="/" /> : <CommandTest />} />
          <Route path="api-logs" element={<ApiLogList />} />
          <Route path="rpm-build" element={<BuildJobs type="rpm" />} />
          <Route path="deb-build" element={<BuildJobs type="deb" />} />
          <Route path="iso-build" element={<BuildJobs type="iso" />} />
          <Route path="build-management" element={role === 'admin' ? <BuildManagement /> : <Navigate to="/" />} />
          <Route path="profile" element={<Profile />} />
        </Route>
        
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
};

export default App;
